/*
 * TODO: Move this to a proper error util file
 */

export const UserCancelled = new Error('user cancelled')
